export default __webpack_public_path__ + "static/half_circle_service_page-b75f8974ab6d65e9a3e46cb98418d649.png";